import { FormEvent } from 'react';
import { Button, Col, Row, FormControl, ButtonGroup, FormGroup, ControlLabel, Form } from 'react-bootstrap';
import { ICenterBase } from '@nkr/models/index';
import { WellWrapper } from './styles';

interface IProps {
    isAdmin: boolean,
    includeNkr: boolean,
    includeDash: boolean,
    startDate: string,
    endDate: string,
    includeNdd: boolean,
    includeDd: boolean,
    includeSv: boolean,
    includeFv: boolean,
    ruleOut: number,
    emrStatus: number,
    centerId: number,
    centerList: ICenterBase[]
    onFilterChange: (includeNkr: boolean, includeDash: boolean, startDate: string, endDate: string, includeNdd: boolean, includeDd: boolean, includeSv: boolean, includeFv: boolean, ruleOut: number, emrStatus: number, centerId: number) => void
    onFilter: () => void,
}

const Filter = (props: IProps) => {
    const handleDashChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let includeDash = !props.includeDash;
        props.onFilterChange(props.includeNkr, includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    }

    const handleNkrChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let includeNkr = !props.includeNkr;
        props.onFilterChange(includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    }

    const handleNddChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let includeNdd = !props.includeNdd;
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    }

    const handleDdChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let includeDd = !props.includeDd;
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    }

    const handleSvChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let includeSv = !props.includeSv;
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    }

    const handleFvChange = (e: React.FormEvent<HTMLButtonElement>) => {
        let includeFv = !props.includeFv;
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, includeFv, props.ruleOut, props.emrStatus, props.centerId);
    }

    const handleEmrStatus = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let emrStatus = parseInt(e.currentTarget.value);
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, emrStatus, props.centerId);
    }

    const handleRuleOut = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let ruleOut = parseInt(e.currentTarget.value);
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, ruleOut, props.emrStatus, props.centerId);
    }

    const handleCenterChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let centerId = parseInt(e.currentTarget.value);
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, centerId);
    }

    const handleStartDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let startDate = e.currentTarget.value;
        props.onFilterChange(props.includeNkr, props.includeDash, startDate, props.endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    };

    const handleEndDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let endDate = e.currentTarget.value;
        props.onFilterChange(props.includeNkr, props.includeDash, props.startDate, endDate, props.includeNdd, props.includeDd, props.includeSv, props.includeFv, props.ruleOut, props.emrStatus, props.centerId);
    };

    return (
        <WellWrapper style={{ marginBottom: 5 }}>
            <Form horizontal>
                <Row style={{ marginBottom: 20 }}>
                    <Col xs={12} lg={3}>
                        <FormGroup>
                            <Col xs={4} componentClass={ControlLabel}>Type:</Col>
                            <Col xs={8}>
                                <ButtonGroup>
                                    <button type='button' className={'btn ' + (props.includeDash ? 'btn-primary active' : 'btn-default')} onClick={handleDashChange}>DASH</button>
                                    <button type='button' className={'btn ' + (props.includeNkr ? 'btn-primary active' : 'btn-default')} onClick={handleNkrChange}>NKR</button>
                                </ButtonGroup>
                            </Col>
                        </FormGroup>
                    </Col>

                    {props.isAdmin && (
                        <Col xs={12} lg={3}>
                            <FormGroup>
                                <Col xs={4} componentClass={ControlLabel}>Center:</Col>
                                <Col xs={8}>
                                    <FormControl
                                        componentClass='select'
                                        style={{ width: 'initial' }}
                                        value={props.centerId}
                                        onChange={handleCenterChange}
                                    >
                                        <option value={0}>- ALL CENTERS -</option>
                                        {props.centerList.map((center, index) =>
                                            <option key={index} value={center.id}>{center.alias}</option>
                                        )}
                                    </FormControl>
                                </Col>
                            </FormGroup>
                        </Col>
                    )}

                    <Col xs={12} lg={3}>
                        <FormGroup>
                            <Col xs={4} componentClass={ControlLabel}>Start Date:</Col>
                            <Col xs={8}>
                                <FormControl
                                    type='date'
                                    name='startDate'
                                    value={props.startDate}
                                    onChange={handleStartDateChange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={3}>
                        <FormGroup>
                            <Col xs={4} componentClass={ControlLabel}>End Date:</Col>
                            <Col xs={8}>
                                <FormControl
                                    type='date'
                                    name='endDate'
                                    value={props.endDate}
                                    onChange={handleEndDateChange}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={3}>
                        <FormGroup>
                            <Col xs={4} componentClass={ControlLabel}>Donor&nbsp;Type:</Col>
                            <Col xs={8}>
                                <ButtonGroup>
                                    <button type='button' className={'btn ' + (props.includeNdd ? 'btn-primary active' : 'btn-default')} onClick={handleNddChange}>NDD</button>
                                    <button type='button' className={'btn ' + (props.includeDd ? 'btn-primary active' : 'btn-default')} onClick={handleDdChange}>DD</button>
                                    <button type='button' className={'btn ' + (props.includeSv ? 'btn-primary active' : 'btn-default')} onClick={handleSvChange}>SV</button>
                                    <button type='button' className={'btn ' + (props.includeFv ? 'btn-primary active' : 'btn-default')} onClick={handleFvChange}>FV</button>
                                </ButtonGroup>
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={3}>
                        <FormGroup>
                            <Col xs={4} componentClass={ControlLabel}>EMR&nbsp;Status:</Col>
                            <Col xs={8}>
                                <FormControl
                                    componentClass='select'
                                    value={props.emrStatus}
                                    onChange={handleEmrStatus}
                                    style={{ width: 'initial' }}
                                >
                                    <option value={0}> Any </option>
                                    <option value={1}> In EMR </option>
                                    <option value={2}> NOT in EMR </option>
                                </FormControl>
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={3}>
                        <FormGroup>
                            <Col xs={4} componentClass={ControlLabel}>Rule Out:</Col>
                            <Col xs={8}>
                                <FormControl
                                    componentClass='select'
                                    value={props.ruleOut}
                                    onChange={handleRuleOut}
                                    style={{ width: 'initial' }}
                                >
                                    <option value={0}> Any </option>
                                    <option value={1}> Archived Rule-Outs Only </option>
                                    <option value={2}> Non-Archived Rule-Outs Only </option>
                                </FormControl>
                            </Col>
                        </FormGroup>
                    </Col>

                    <Col xs={12} lg={3}>
                        <Col xs={12} lg={5} style={{ float: 'right' }}>
                            <Button bsStyle='primary' block onClick={props.onFilter}>Apply Filter</Button>
                        </Col>
                    </Col>
                </Row>
            </Form>
        </WellWrapper>
    );
}

export default Filter;
